module.exports = __webpack_public_path__ + "img/应用场景_客户考察.0efe8d67.png";